import moment from 'moment';

let questionsMap = {};

function isNumber(value)
{
  return typeof value === 'number' && isFinite(value);
}

const generateWeeks = (phaseOpenedAt, phaseClosedAt, weeks) => {
  let openedAt = moment(phaseOpenedAt);
  let startAtTmp = openedAt.clone();
  let weeksArray = [];
  for (let i = 0; i < weeks; i++) {
    let startAt = startAtTmp.clone().startOf('isoWeek');
    let endsAt = startAt.clone().add(7, 'days')
    weeksArray.push({
      numInPhase: i + 1,
      weekNumber: startAt.isoWeek(),
      startAt: startAt.clone(),
      endsAt,
      startsAtFormatted: startAt.format('YYYY-MM-DD'),
      endstAtFormatted: endsAt.format('YYYY-MM-DD'),
      weekNumberWithYear: startAt.isoWeek() + ((startAt.year() - 2000) * 60),
      phaseOpenedAt,
      phaseClosedAt,
      header: `Week ${i + 1}`,
      days: []
    });
    startAtTmp.add(7, 'days');
  }

  return weeksArray;
};

const generatePhaseWeeks = (phaseOpenedAt, phaseClosedAt, weeks) => {
  let openedAt = moment(phaseOpenedAt);
  let startAtTmp = openedAt.clone();
  let weeksArray = [];
  for (let i = 0; i < weeks; i++) {
    let startAt = startAtTmp.clone();
    let endsAt = startAtTmp.clone().add(7, 'days')
    weeksArray.push({
      numInPhase: i + 1,
      weekNumber: startAt.isoWeek(),
      startAt: startAt.clone(),
      endsAt,
      startsAtFormatted: startAt.format('YYYY-MM-DD'),
      endstAtFormatted: endsAt.format('YYYY-MM-DD'),
      weekNumberWithYear: startAt.isoWeek() + ((startAt.year() - 2000) * 60),
      phaseOpenedAt,
      phaseClosedAt,
      header: `Week ${i + 1}`,
      days: []
    });
    startAtTmp.add(7, 'days');
  }

  return weeksArray;
};

const hasAddedPrompt = (questions, prompt) =>
  questions.find(question => question.toLowerCase().includes(prompt.toLowerCase()))
  || questions.find(question => prompt.toLowerCase().includes(question.toLowerCase()))

const applyScoreOverride = (response, fieldConfig) => {
  if (response && response.rating && fieldConfig && fieldConfig.overrideDefaultScores) {
    return {
      ...response,
      ratingLabel: fieldConfig.scoreOverrides[response.rating] || response.rating
    }
  }

  return response || {}
}

const generateResponsesMap = (layout, responses, questions, responsesAck = {}, performanceExceptions = [], dateHash = null) => {
  let responsesMap = {};
  let timeSpend = 0
  responsesAck = responsesAck || {}

  for (let i = 0; i < responses.length; i++) {
    let response = responses[i];
    let sequence = parseInt(response.sequence);
    if (layout[sequence] && layout[sequence].schema && layout[sequence].schema.startsWith('rating')) {

      let ratingPrompt = layout[sequence].ratingPrompt || layout[sequence].prompt;
      if (ratingPrompt && ratingPrompt !== ' ') {
        let question = hasAddedPrompt(questions, ratingPrompt);
        let fieldConfig = layout[sequence];
        if(fieldConfig && fieldConfig.overrideDefaultScores) {
          response.ratingLabel = fieldConfig.scoreOverrides[response.rating] || response.rating
        }
        if (question) {
          if((response.rating <= 2 && response.rating > 0) || response.notResponsive) {
            performanceExceptions.push({category: question, date: dateHash, score: response.rating, notes: response.comment})
          }
          responsesMap[question] = response
          if (response.timeSpend) {
            let timeSpendTmp = response.timeSpend;
            if (!isNumber(response.timeSpend) && response.timeSpend && response.timeSpend.includes(':')) {
              timeSpendTmp = (parseInt(response.timeSpend.split(':')[0]) * 60) + parseInt(response.timeSpend.split(':')[1])
            } else {
              timeSpendTmp = parseInt(response.timeSpend);
            }
            if (!isNaN(timeSpendTmp)) {
              timeSpend += timeSpendTmp
            }
          }
        }
      }

    } else if (layout[sequence] && layout[sequence].schema && layout[sequence].schema === 'evaluation-rating') {
      let ratingPrompt = layout[sequence].ratingPrompt || layout[sequence].prompt;

      if (ratingPrompt && ratingPrompt !== ' ') {
        let question = hasAddedPrompt(questions, ratingPrompt);
        let fieldConfig = layout[sequence];
        if (question) {
          let traineeEvaluation = applyScoreOverride(response, fieldConfig)
          let trainerEvaluation = applyScoreOverride(responsesAck[layout[sequence].id], fieldConfig)
          let combinedResponse = {
            ...response,
            ...trainerEvaluation,
            isEvaluationRating: true,
            scale: fieldConfig.scale,
            traineeEvaluation,
            trainerEvaluation,
            rating: trainerEvaluation.rating,
            ratingLabel: trainerEvaluation.ratingLabel,
            notObserved: trainerEvaluation.notObserved,
            notResponsive: trainerEvaluation.notResponsive,
            comment: trainerEvaluation.comment,
            traineeComment: traineeEvaluation.comment,
            trainerComment: trainerEvaluation.comment
          }

          if((trainerEvaluation.rating <= 2 && trainerEvaluation.rating > 0) || trainerEvaluation.notResponsive) {
            performanceExceptions.push({category: question, date: dateHash, score: trainerEvaluation.rating, notes: trainerEvaluation.comment})
          }
          responsesMap[question] = combinedResponse
          if (response.timeSpend) {
            let timeSpendTmp = response.timeSpend;
            if (!isNumber(response.timeSpend) && response.timeSpend && response.timeSpend.includes(':')) {
              timeSpendTmp = (parseInt(response.timeSpend.split(':')[0]) * 60) + parseInt(response.timeSpend.split(':')[1])
            } else {
              timeSpendTmp = parseInt(response.timeSpend);
            }
            if (!isNaN(timeSpendTmp)) {
              timeSpend += timeSpendTmp
            }
          }
        }
      }
    } else if (layout[sequence] && layout[sequence].schema && layout[sequence].schema === 'pto-rating-multi') {
      let ratingPrompt = layout[sequence].ratingPrompt || layout[sequence].prompt;

      if (ratingPrompt && ratingPrompt !== ' ') {
        let question = hasAddedPrompt(questions, ratingPrompt);
        if (question) {
          let responseAck = responsesAck[layout[sequence].id] || {}
          responsesMap[question] = {...response, ...responseAck}
          if (response.timeSpend) {
            let timeSpendTmp = response.timeSpend;
            if (response.timeSpend.includes(':')) {
              timeSpendTmp = (parseInt(response.timeSpend.split(':')[0]) * 60) + parseInt(response.timeSpend.split(':')[1])
            } else {
              timeSpendTmp = parseInt(response.timeSpend);
            }
            if (!isNaN(timeSpendTmp)) {
              timeSpend += timeSpendTmp
            }
          }
        }
      }
    }
  }

  return {responsesMap, timeSpend}
};

const generateTimeResponse = (layout, responses, questions, responsesAck = {}) => {
  for (let i = 0; i < responses.length; i++) {
    let response = responses[i];
    let sequence = parseInt(response.sequence);
    if (layout[sequence] && layout[sequence].schema && layout[sequence].schema === 'time-field') {
      return response
    }
  }

  return null
}

const isDateBigger = (dateA, dateB) => {
  return (new Date(dateA.format('YYYY-MM-DD'))).getTime() > (new Date(dateB.format('YYYY-MM-DD'))).getTime()
}

const initializeReportsMapsForWeeks = (weeks) => {
  weeks.forEach((week, index) => {
    let startDate = week.startAt.clone();
    for (let i = 0; i < 7; i++) {
      let dateHash = startDate.format('MM/DD/YYYY');
      if (isDateBigger(startDate, moment(week.phaseOpenedAt)) && (!week.phaseClosedAt || isDateBigger(moment(week.phaseClosedAt), startDate) || (index < weeks.length - 1))) {
        !week.days.find(day => day === dateHash) && week.days.push(dateHash);
      }
      startDate = moment(startDate.toDate()).add(1, 'days')
    }
  });
};

const calculateWeeklyAvg = (weeklyAvgMap, week, responsesMap, phaseGuid) => {
  Object.keys(responsesMap)
    .forEach((key) => {
      let wAvgRow = weeklyAvgMap[`${phaseGuid}#${key}#${week}`]
      if (!wAvgRow) {
        wAvgRow = {
          avgRating: 0,
          timeSpendAvg: 0,
          ratings: [],
          timeSpend: []
        }
      }
      let rating = responsesMap[key].rating;
      if (rating && !isNaN(rating)) {
        wAvgRow.ratings.push(rating);
        wAvgRow.avgRating = (wAvgRow.ratings.reduce((sum, rating) => {
          return sum + rating
        }, 0) / wAvgRow.ratings.length).toFixed(2);
      }

      let timeSpend = responsesMap[key].timeSpend;

      if (timeSpend) {
        let timeSpendTmp = timeSpend;
        if (!isNumber(timeSpend) && timeSpend && timeSpend.includes(':')) {
          timeSpendTmp = (parseInt(timeSpend.split(':')[0]) * 60) + parseInt(timeSpend.split(':')[1])
        } else {
          timeSpendTmp = parseInt(timeSpend);
        }

        if (!isNaN(timeSpendTmp)) {
          wAvgRow.timeSpend.push(timeSpendTmp);
          wAvgRow.timeSpendAvg = wAvgRow.timeSpend.reduce((sum, timeSpend) => {
            return sum + timeSpend
          }, 0)
        }
      }

      weeklyAvgMap[`${phaseGuid}#${key}#${week}`] = wAvgRow;

    })
}

const calculatePhaseAvg = (phaseAvgMap, responsesMap, phaseGuid) => {
  Object.keys(responsesMap)
    .forEach((key) => {
      let pAvgRow = phaseAvgMap[`${phaseGuid}#${key}#`]
      if (!pAvgRow) {
        pAvgRow = {
          avgRating: 0,
          timeSpendAvg: 0,
          ratings: [],
          timeSpend: []
        }
      }
      let rating = responsesMap[key].rating;
      if (rating && !isNaN(rating)) {
        pAvgRow.ratings.push(rating);
        pAvgRow.avgRating = (pAvgRow.ratings.reduce((sum, rating) => {
          return sum + rating
        }, 0) / pAvgRow.ratings.length).toFixed(2);
      }

      let timeSpend = responsesMap[key].timeSpend;

      if (timeSpend) {
        let timeSpendTmp = timeSpend;
        if (!isNumber(timeSpend) && timeSpend && timeSpend.includes(':')) {
          timeSpendTmp = (parseInt(timeSpend.split(':')[0]) * 60) + parseInt(timeSpend.split(':')[1])
        } else {
          timeSpendTmp = parseInt(timeSpend);
        }

        if (!isNaN(timeSpendTmp)) {
          pAvgRow.timeSpend.push(timeSpendTmp);
          pAvgRow.timeSpendAvg = pAvgRow.timeSpend.reduce((sum, timeSpend) => {
            return sum + timeSpend
          }, 0)
        }
      }

      phaseAvgMap[`${phaseGuid}#${key}#`] = pAvgRow;

    })
}

const calculateTotalAvg = (totalAvgMap, responsesMap) => {
  Object.keys(responsesMap)
    .forEach((key) => {
      let pAvgRow = totalAvgMap[`#${key}#`]
      if (!pAvgRow) {
        pAvgRow = {
          avgRating: 0,
          timeSpendAvg: 0,
          ratings: [],
          timeSpend: []
        }
      }
      let rating = responsesMap[key].rating;
      if (rating && !isNaN(rating)) {
        pAvgRow.ratings.push(rating);
        pAvgRow.avgRating = (pAvgRow.ratings.reduce((sum, rating) => {
          return sum + rating
        }, 0) / pAvgRow.ratings.length).toFixed(2);
      }

      let timeSpend = responsesMap[key].timeSpend;

      if (timeSpend) {
        let timeSpendTmp = timeSpend;
        if (!isNumber(timeSpend) && timeSpend && timeSpend.includes(':')) {
          timeSpendTmp = (parseInt(timeSpend.split(':')[0]) * 60) + parseInt(timeSpend.split(':')[1])
        } else {
          timeSpendTmp = parseInt(timeSpend);
        }

        if (!isNaN(timeSpendTmp)) {
          pAvgRow.timeSpend.push(timeSpendTmp);
          pAvgRow.timeSpendAvg = pAvgRow.timeSpend.reduce((sum, timeSpend) => {
            return sum + timeSpend
          }, 0)
        }
      }

      totalAvgMap[`#${key}#`] = pAvgRow;

    })
}

const getReportDate = (report) => {
  let dateA = report.responses.find(response => response.datetime);
  dateA = dateA && dateA.datetime;

  if (report.schedule) {
    dateA = report.schedule.observationDate;
  }
  if (!dateA) {
    dateA = report.insertedAt
  }
  return dateA
}

const generateReportsMap = (reportMap, reports, phase, weeks, questions, weeklyAvgMap, phaseAvgMap, totalAvgMap, performanceExceptions) => {
  let minWeek = weeks[0].weekNumber;
  let maxWeek = weeks[weeks.length - 1].weekNumber;
  let minWeekByYear = weeks[0].weekNumberWithYear;
  let maxWeekByYear = weeks[weeks.length - 1].weekNumberWithYear;

  initializeReportsMapsForWeeks(weeks);

  let groupedReports = reports
    .sort((a, b) => {
      let dateA = a.responses.find(response => response.datetime);
      dateA = dateA && dateA.datetime;

      if (a.schedule) {
        dateA = a.schedule.observationDate;
      }
      if (!dateA) {
        dateA = a.insertedAt
      }

      let dateB = b.responses.find(response => response.datetime);
      dateB = dateB && dateB.datetime;

      if (b.schedule) {
        dateB = b.schedule.observationDate;
      }
      if (!dateB) {
        dateB = b.insertedAt
      }
      return (new Date(dateA)).getTime() - (new Date(dateB)).getTime()
    })
    .reduce((acc, report) => {
      let dateTime = getReportDate(report)
      let date = (new Date(dateTime).toLocaleDateString())
      return {
        ...acc,
        [date]: [
          ...(acc[date] || []),
          report
        ]
      }
    }, {})

  return Object.keys(groupedReports)
    .sort((a, b) => new Date(a) - new Date(b))
    .map((key, index) => groupedReports[key].map(r => {
      r.sequence = index + 1;
      return r
    }))
    .reduce((acc, reports) => [...acc, ...reports], [])
    .reduce((map, report) => {
      let date = report.responses.find(response => response.datetime);
      date = date && date.datetime;

      if (report.schedule) {
        date = report.schedule.observationDate;
      }

      if (!date) {
        date = report.insertedAt
      }

      let endOfWeekDate = moment(date);
      let dateFormatted = endOfWeekDate.format('YYYY-MM-DD')
      let week = endOfWeekDate.isoWeek();
      let weekByYear = endOfWeekDate.isoWeek() + ((endOfWeekDate.year() - 2000) * 60);

      let weekObjByRange = weeks.find(weekObjTmp => {
        return moment(dateFormatted).isBetween(weekObjTmp.startsAtFormatted, weekObjTmp.endstAtFormatted)
      })

      if (weekObjByRange) {
        week = weekObjByRange.weekNumber
        // console.log('weekObjByRange', weekObjByRange)
      }

      // if (weekByYear < minWeekByYear) {
      //   console.log('weekByYear < minWeekByYear', week, minWeek, weekByYear , minWeekByYear)
      //   week = minWeek
      // } else if (weekByYear > maxWeekByYear) {
      //   console.log('weekByYear > maxWeekByYear', week, maxWeek, weekByYear , maxWeekByYear)
      //   week = maxWeek
      // }

      let dateHash = moment(date).format('MM/DD/YYYY');

      let weekObj = weeks.find(w => w.weekNumber === week);

      if (weekObjByRange) {
        weekObj = weekObjByRange
      }

      if (weekObj) {
        !weekObj.days.find(day => day === dateHash) && weekObj.days.push(dateHash);

        weekObj.days = weekObj.days.sort((a, b) => {
          let [monthA, dayA, yearA] = a.split('/');
          let [monthB, dayB, yearB] = b.split('/');

          return (parseInt(yearA) * 365 + parseInt(monthA) * 30 + parseInt(dayA)) - (parseInt(yearB) * 365 + parseInt(monthB) * 30 + parseInt(dayB))
        })
      }

      let hash = `${phase.guid}${week}${dateHash}`;
      let {
        responsesMap,
        timeSpend
      } = generateResponsesMap(report.layout, report.responses, questions, report.responsesAck, performanceExceptions, dateHash)

      let time = generateTimeResponse(report.layout, report.responses, questions, report.responsesAck)

      if(time) {
        phaseAvgMap[`${phase.guid}#time`] = [...( phaseAvgMap[`${phase.guid}#time`] || []), time]
        totalAvgMap[`#time`] = [...( totalAvgMap[`#time`] || []), time]
      }

      calculateWeeklyAvg(weeklyAvgMap, week, responsesMap, phase.guid);
      calculatePhaseAvg(phaseAvgMap, responsesMap, phase.guid);
      calculateTotalAvg(totalAvgMap, responsesMap);

      return ({
        ...map,
        [hash]: [
          ...(map[hash] || []),
          {
            ...report,
            date,
            responsesMap,
            timeSpend,
            time
          }
        ]
      });
    }, reportMap)
};

const getLatestQuestions = (phases) => {
  let reports = phases.reduce((acc, phase) => [...acc, ...phase.attributes.reports], []);
  reports.sort((a, b) => {
    let dateA = a.insertedAt
    let dateB = b.insertedAt
    return (new Date(dateB)).getTime() - (new Date(dateA)).getTime()
  })

  let lastReport = reports[0];
  let questions = [];
  let questionsMapById = {}
  let timeTrack = null

  if (lastReport) {
    let responses = lastReport.responses;
    let layout = lastReport.layout;

    for (let i = 0; i < responses.length; i++) {
      let response = responses[i];
      let sequence = parseInt(response.sequence);
      if (layout[sequence] && layout[sequence].schema && (layout[sequence].schema.startsWith('rating') || layout[sequence].schema === 'evaluation-rating')) {
        let ratingPrompt = layout[sequence].ratingPrompt || layout[sequence].prompt;
        if (ratingPrompt && ratingPrompt !== ' ') {
          questions.push(ratingPrompt);
          questionsMap[ratingPrompt] = true;
          questionsMapById[layout[sequence].id] = layout[sequence];
        }
      } else if (layout[sequence] && layout[sequence].schema && layout[sequence].schema === 'pto-rating-multi') {
        let ratingPrompt = layout[sequence].ratingPrompt || layout[sequence].prompt;
        if (ratingPrompt && ratingPrompt !== ' ') {
          questions.push(ratingPrompt);
          questionsMap[ratingPrompt] = true;
          questionsMapById[layout[sequence].id] = layout[sequence];
        }
      } else if (layout[sequence] && layout[sequence].schema && layout[sequence].schema === 'time-field') {
        timeTrack = layout[sequence];
      }
    }

    return [questions, questionsMapById, timeTrack];
  } else {
    return [[], {}]
  }
}

const groupLogReport = (oitData) => {
  let res = oitData
    .sort((a, b) => (new Date(a.attributes.openedAt)).getTime() - (new Date(b.attributes.openedAt)).getTime())
    .reduce((acc, phase) => {
      if (phase.attributes.type === "orientation") {
        return acc;
      }

      let sorted = phase.attributes.reports
        .sort((a, b) => {
          let dateA= getReportDate(a);
          let dateB= getReportDate(b);
          return (new Date(dateA)).getTime() - (new Date(dateB)).getTime()
        })


      return sorted
        .reduce((logAcc,  report) => {
        let logFields = report.layout.filter(field => field.schema === 'log-field');
        let reportDate = getReportDate(report);

        return logFields.reduce((logFieldsAcc, logField) =>  {
          let logFieldIndex = report.layout.filter(field => field.type !== 'header').findIndex(field => field === logField);
          if(logField) {
            let responses = report.responses[logFieldIndex]
            try {
              return {
                ...logFieldsAcc,
                [logField.id]: {
                  logField,
                  list: [
                    ...(logFieldsAcc[logField.id] && logFieldsAcc[logField.id].list || []),
                    ...(responses.list? responses.list.map(rl => ({...rl, date: reportDate, trainingPhaseHeader: phase.attributes.header, trainingPhaseGuid: phase.attributes.sequence, reportGuid: report.reportGuid, groupBy: logField.groupBy})) : [])
                  ]
                }
              };
            } catch (ex) {
              console.log('EX', ex)
              return logFieldsAcc
            }
          }
        }, logAcc )
      }, acc)

    }, {})

  return Object.keys(res).map(key => res[key]);
}

const getFirstAndLastReportDates = (reports, mapWeeksToPhase, phase) => {
  let sortedReport = [...reports]
    .sort((a, b) => {
      let dateA = a.responses.find(response => response.datetime);
      dateA = dateA && dateA.datetime;

      if (a.schedule) {
        dateA = a.schedule.observationDate;
      }
      if (!dateA) {
        dateA = a.insertedAt
      }

      let dateB = b.responses.find(response => response.datetime);
      dateB = dateB && dateB.datetime;

      if (b.schedule) {
        dateB = b.schedule.observationDate;
      }
      if (!dateB) {
        dateB = b.insertedAt
      }
      return (new Date(dateA)).getTime() - (new Date(dateB)).getTime()
    })

  let firstReport = sortedReport[0];
  let lastReport = sortedReport[sortedReport.length - 1]
  if(firstReport && lastReport) {
    let dateA = firstReport.responses.find(response => response.datetime);
    dateA = dateA && dateA.datetime;

    if (firstReport.schedule) {
      dateA = firstReport.schedule.observationDate;
    }
    if (!dateA) {
      dateA = firstReport.insertedAt
    }


    let dateB = lastReport.responses.find(response => response.datetime);
    dateB = dateB && dateB.datetime;

    if (lastReport.schedule) {
      dateB = lastReport.schedule.observationDate;
    }
    if (!dateB) {
      dateB = lastReport.insertedAt
    }
    dateB = moment(dateB)

    // console.log(phase, moment(dateA).startOf('day').startOf('isoWeek'), moment(dateB).endOf('day').endOf('isoWeek'), moment(dateA).startOf('isoWeek').dayOfYear(), moment(dateB).endOf('isoWeek').dayOfYear(), moment(dateB).startOf('isoWeek'),Math.ceil((moment(dateB).endOf('isoWeek').endOf('day')).diff(moment(dateA).startOf('isoWeek').startOf('day'), 'days', true) / 7), Math.ceil(moment(dateB).diff(moment(dateA), 'days', true) / 7), moment(dateB).isoWeek() , moment(dateA).isoWeek())
    if(mapWeeksToPhase) {
      // console.log(moment(dateA).diff(moment(dateB), 'days', false))
      // console.log(Math.ceil(moment(dateA).diff(moment(dateB), 'days', false) / 7))
      return Math.ceil(moment(dateB).diff(moment(dateA), 'days', false) / 7)
    }
    dateA = moment.min([moment(dateA), moment(phase.attributes.openedAt)])

    // console.log('moment(dateA).startOf(\'isoWeek\')', phase, moment(dateA).startOf('isoWeek'))

    return Math.ceil((moment(dateB)).diff(moment(dateA).startOf('isoWeek'), 'days', false) / 7)
    // dateB = moment(dateB);
    // dateA = moment(dateA);
    // let weeksA =  dateA.year() * dateA.weeksInYear() + dateA.isoWeek();
    // let weeksB =  dateB.year() * dateB.weeksInYear() + dateB.isoWeek();
    //
    // console.log( weeksB, weeksA, weeksB - weeksA)
    //
    // return weeksB - weeksA
  }

  return 0
}

const normalizeOitReport = (oitData, mapWeekToPhase) => {
  let logReport = groupLogReport(oitData);
  questionsMap = {};
  let [questions, questionsMapById, timeField] = getLatestQuestions(oitData);
  let weeklyAvgMap = {}
  let phaseAvgMap = {}
  let totalAvgMap = {}
  let performanceExceptions = []

  let result = oitData
    .sort((a, b) => (new Date(a.attributes.openedAt)).getTime() - (new Date(b.attributes.openedAt)).getTime())
    .reduce((acc, phase) => {
      if (phase.attributes.type === "orientation") {
        return acc;
      } else {
        let calcWeeks = getFirstAndLastReportDates(phase.attributes.reports, mapWeekToPhase, phase)
        let weeks = mapWeekToPhase
          ? generatePhaseWeeks(phase.attributes.openedAt, phase.attributes.closedAt, calcWeeks > phase.attributes.weeks ? calcWeeks: phase.attributes.weeks)
          : generateWeeks(phase.attributes.openedAt, phase.attributes.closedAt, calcWeeks > phase.attributes.weeks ? calcWeeks: phase.attributes.weeks);

        let newPhase = {
          guid: phase.trainingPhaseGuid,
          header: phase.attributes.header,
          sequence: phase.attributes.sequence,
          fto: phase.attributes.fto
        };

        return {
          ...acc,
          questions,
          phases: [...acc.phases, newPhase],
          weeks: {
            ...acc.weeks,
            [phase.trainingPhaseGuid]: weeks
          },
          reportMap: generateReportsMap(acc.reportMap, phase.attributes.reports, newPhase, weeks, questions, weeklyAvgMap, phaseAvgMap, totalAvgMap, performanceExceptions)
        }
      }
    }, {
      phases: [],
      weeks: {},
      days: [],
      questions: [],
      reportMap: {}
    });

  return {...result, weeklyAvgMap, phaseAvgMap, totalAvgMap, questionsMapById, timeField, logReport, performanceExceptions};
};

export {
  normalizeOitReport
}
